/**
 * PATH: apps/quote/src/components/builder/phantom-row/SuggestionsDropdown.tsx
 * PURPOSE: AI suggestions dropdown for phantom row description input
 */

import { Sparkles } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { AISuggestion } from '@/lib/quoteApi'

interface SuggestionsDropdownProps {
  suggestions: AISuggestion[]
  selectedIndex: number
  onSelect: (suggestion: AISuggestion) => void
  onHover: (index: number) => void
}

export function SuggestionsDropdown({ suggestions, selectedIndex, onSelect, onHover }: SuggestionsDropdownProps) {
  return (
    <div className="absolute left-0 right-0 top-full z-50 mt-1 bg-white dark:bg-slate-900 rounded-lg shadow-xl border border-slate-200 dark:border-slate-700 max-h-64 overflow-y-auto">
      <div className="p-2 border-b border-slate-100 dark:border-slate-800 text-xs text-slate-500 flex items-center gap-1">
        <Sparkles className="w-3 h-3 text-amber-500" />
        AI Suggestions • ↑↓ to navigate • Enter to select
      </div>
      {suggestions.map((suggestion, idx) => (
        <button
          key={suggestion.id}
          onClick={() => onSelect(suggestion)}
          onMouseEnter={() => onHover(idx)}
          className={cn(
            'w-full px-3 py-2 text-left hover:bg-blue-50 dark:hover:bg-blue-900/20 flex items-center justify-between gap-2',
            idx === selectedIndex && 'bg-blue-50 dark:bg-blue-900/20'
          )}
        >
          <div className="flex-1 min-w-0">
            <div className="text-sm font-medium text-slate-900 dark:text-white truncate">{suggestion.item_name}</div>
            <div className="text-xs text-slate-500 truncate">{suggestion.source} • {suggestion.unit}</div>
          </div>
          <div className="text-right shrink-0">
            <div className="text-sm font-semibold text-blue-600">${suggestion.unit_price?.toFixed(2)}</div>
            <div className="text-xs text-slate-400">{Math.round(suggestion.confidence)}% match</div>
          </div>
        </button>
      ))}
    </div>
  )
}
